import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { SA, Reduce } from 'src/util/Redux';

export type Store<T extends SA> = {
  getState: () => T['state'],
  dispatch: (action: T['action']) => void,
  subscribe: (callback: () => void) => void
};

export function Store<T extends SA>(
  initState: T['state'],
  reduce: Reduce<T>
): Store<T> {
  const reduxStore = createStore(
    (app, action) => reduce(
      app || initState,
      action as T['action'],
    ),
    initState,
    composeWithDevTools()
  );

  const getState = () => (
    (reduxStore.getState() || initState) as T['state']
  );

  const dispatch = (action: T['action']) => reduxStore.dispatch(action);

  const subscribe = reduxStore.subscribe;

  return {
    getState,
    dispatch,
    subscribe,
  };
}

export default Store;



// WEBPACK FOOTER //
// ./src/state/Store.ts